import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function CarService({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        d='M18.0026 14.0009C20.2127 14.0009 22.0043 15.7925
         22.0043 18.0025C22.0043 20.2126 20.2127 22.0042
         18.0026 22.0042C15.7926 22.0042 14.001 20.2126
          14.001 18.0025C14.001 15.7925 15.7926 14.0009
           18.0026 14.0009'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M19.3514 17.3292L17.6667 19.0189L16.6543 18.0025'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.32298 11.4708H6.2041'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M16.8552 11.4708H14.7363'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M17.915 8.29247L20.0329 7.23303'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.14427 8.29247L3.02539 7.23303'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.0824 2.99622C7.09785 2.99632 6.24296 3.67427
         6.01854 4.6329L5.11816 8.4745L6.01854 4.6329C6.24296
          3.67427 7.09785 2.99632 8.0824 2.99622H14.9763C15.9607
           2.99604 16.8155 3.67421 17.0391 4.6329L17.9395 8.4745'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M20.0325 12V11.2097C20.0325 9.64596 18.766 8.3777
         17.2023 8.37549H5.86057C5.10873 8.37522 4.38758
          8.67371 3.85586 9.20525C3.32413 9.73679 3.02539
           10.4578 3.02539 11.2097V16.0017C3.02539 16.5542
            3.47329 17.0021 4.02581 17.0021H6.26274C6.81525
             17.0021 7.26316 16.5542 7.26316 16.0017V14.6481H12.0001'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CarService.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default CarService
